export default __webpack_public_path__ + "static/media/laco_logo_slogan.6f5a27f6.png";